/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_New_List_Get_StartedInputs */

const en_create_new_list_get_started = /** @type {(inputs: Create_New_List_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a new list to get started.`)
};

const fr_create_new_list_get_started = /** @type {(inputs: Create_New_List_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez une nouvelle liste pour commencer.`)
};

const de_create_new_list_get_started = /** @type {(inputs: Create_New_List_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie zunächst eine neue Liste.`)
};

const it_create_new_list_get_started = /** @type {(inputs: Create_New_List_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per iniziare, crea un nuovo elenco.`)
};

const ru_create_new_list_get_started = /** @type {(inputs: Create_New_List_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для начала создайте новый список.`)
};

const es_create_new_list_get_started = /** @type {(inputs: Create_New_List_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una nueva lista para comenzar.`)
};

const zh_cn2_create_new_list_get_started = /** @type {(inputs: Create_New_List_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首先创建一个新列表。`)
};

const ja_create_new_list_get_started = /** @type {(inputs: Create_New_List_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始するには新しいリストを作成してください。`)
};

const hi_create_new_list_get_started = /** @type {(inputs: Create_New_List_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरुआत करने के लिए एक नई सूची बनाएं।`)
};

const pt_pt2_create_new_list_get_started = /** @type {(inputs: Create_New_List_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie uma nova lista para começar.`)
};

/**
* | output |
* | --- |
* | "Create a new list to get started." |
*
* @param {Create_New_List_Get_StartedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const create_new_list_get_started = /** @type {((inputs?: Create_New_List_Get_StartedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_New_List_Get_StartedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_create_new_list_get_started(inputs)
	if (locale === "de") return de_create_new_list_get_started(inputs)
	if (locale === "it") return it_create_new_list_get_started(inputs)
	if (locale === "ru") return ru_create_new_list_get_started(inputs)
	if (locale === "es") return es_create_new_list_get_started(inputs)
	if (locale === "zh-CN") return zh_cn2_create_new_list_get_started(inputs)
	if (locale === "ja") return ja_create_new_list_get_started(inputs)
	if (locale === "hi") return hi_create_new_list_get_started(inputs)
	if (locale === "pt-PT") return pt_pt2_create_new_list_get_started(inputs)
	return en_create_new_list_get_started(inputs)
});